import { format } from 'date-fns';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { trackMixpanelEvent } from 'utils/analytics';

import { useGetWorkforceResourcesSupervisors } from '@/modules/home/apiHooks';
import { workforceResourcesSupervisorsColumns } from '@/modules/home/components/PageContent/WorkforceSections/logic';
import { useHomePageContext } from '@/modules/home/context';
import AddEditTeamMember from '@/modules/settings/Team/components/AddEditTeamMember';
import { Button, Table } from '@/shared/components/atoms';
import { EmptyCard } from '@/shared/components/molecules';
import ConfirmationModal from '@/shared/components/molecules/ConfirmationModal';
import { useAuth } from '@/shared/hooks/context/auth';
import { useStore } from '@/shared/hooks/context/createGenericContext';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import Farmer from '~/images/shared/Farmer.svg';

const WorkforceResourcesSupervisors = () => {
  const { t } = useTranslation('common');
  const { locale } = useRouter();
  const { user } = useAuth();
  const [selectedAsset] = useStore((store) => store?.asset);
  const {
    state: { date },
  } = useHomePageContext();

  const { data } = useGetWorkforceResourcesSupervisors({
    entityId: selectedAsset?.id,
    date: format(date, 'yyyy-MM-dd'),
  });

  const { openModal, closeModal } = useModal();

  const handleAddSupervisor = () => {
    trackMixpanelEvent('Onboarding_start_invite_teams', user);
    openModal(
      <AddEditTeamMember formName='onboarding home add team member' />,
      {
        title: t('onboarding-step-2-title'),
        variant: 'full',
        onClose: () =>
          openModal(
            <ConfirmationModal
              header={t('going-somewhere-else')}
              message={t('you-will-lose-all-data')}
              variant='warning'
              dismissText={t('continue-editing')}
              confirmText={t('discard-and-exit')}
              onDismissRemoveNumber={1}
              onConfirm={closeModal}
              buttonsAlignment='col'
              preferredAction='dismiss'
            />
          ),
      }
    );
  };

  return data?.length ? (
    <Table
      selection={false}
      headerClassName='sticky'
      tableWrapperClassName='max-h-412 overflow-y-auto'
      headCellClassName='text-start [&>div]:text-14 border-b-xs border-neutralVariant-90 text-surface-10'
      headContainerClassName='!bg-background-neutral-99'
      tableClassName='!border-collapse'
      rowContainerClassName='!bg-background-transparent last-of-type:border-b-0 border-neutralVariant-90 border-b-xs'
      columns={workforceResourcesSupervisorsColumns(t, locale)}
      data={data}
      pagination={false}
    />
  ) : (
    <div className='my-40 flex flex-grow items-center justify-center px-40'>
      <div>
        <EmptyCard
          message={t('no-supervisors')}
          vector={
            <span className='text-40 text-primary-60'>
              {/* TODO: fix farmer color */}
              <Farmer />
            </span>
          }
          variant='icon'
          classeName='!font-bold'
        />
        <Button
          variant='text'
          size='none'
          className='mt-8 h-40 border-xs border-outline-default px-16 font-medium'
          onClick={handleAddSupervisor}
        >
          {t('add-supervisor')}
        </Button>
      </div>
    </div>
  );
};
export { WorkforceResourcesSupervisors };
